define('areas/organizationmanager/commands/downloadmemberpdfcommand',["require", "exports", "models/account", "services/trace", "services/settings"], function (require, exports, Account, Trace, Configuration) {
    "use strict";
    var DownloadMemberPdfCommand = (function () {
        function DownloadMemberPdfCommand() {
        }
        DownloadMemberPdfCommand.prototype.execute = function (member) {
            try {
                var path = "download/logindocument/zugangsdaten.pdf";
                var query = "?organizationId=" + member.organizationId + "&memberId=" + member.id + "&sessionId=" + Account.Principal.current.sessionId;
                var service = Configuration.Settings.getServiceFor("portalstorage", path, query);
                window.open(service, "_blank");
            }
            catch (exception) {
                Trace.traceError(exception, null, "organizationmanager:index", true);
            }
        };
        return DownloadMemberPdfCommand;
    }());
    return DownloadMemberPdfCommand;
});

